import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';

import { AuthService } from '../../services/auth.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  logueando = false;

  constructor(
    private authService: AuthService,
    private notifier: NotifierService) { }

  ngOnInit() {
  }

  signIn() {
    this.logueando = true;
    this.authService.signInWithProvider().subscribe(res => {
      this.notifier.notify( 'error', res );
      this.logueando = false;
    }, error => {
      console.log(error);
      this.logueando = false;
    });
  }

  noSignin() {
  }
}
